import { render, staticRenderFns } from "./personnelAdd.vue?vue&type=template&id=2f658273&scoped=true&"
import script from "./personnelAdd.vue?vue&type=script&lang=js&"
export * from "./personnelAdd.vue?vue&type=script&lang=js&"
import style0 from "./personnelAdd.vue?vue&type=style&index=0&id=2f658273&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f658273",
  null
  
)

export default component.exports